import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
function AuthResponse() {
  const navigate = useNavigate()
  useEffect(() => {
    navigate("/monitor")
  }, [])
  return <div className="App"></div>
}

export default AuthResponse
